import CardMedia from '@mui/material/CardMedia';
import LOGO from '../static/logo/MOD-LOGO.png';
import Stack from '@mui/material/Stack';

export function Header() {
  return (
    <Stack direction='row' justifyContent='center' alignItems='center'>
      <CardMedia
        sx={{ width: '50vw', maxWidth: { xs: 200, md: 200 } }}
        component='img'
        image={LOGO}
        alt='Logo'
      ></CardMedia>
    </Stack>
  );
}
